<!-- eslint-disable no-undef -->
<template>
  <div class="service-page">
  <div
    v-if="isLoad"
    class="container-wrapper service-request-page margin-space"
    @submit.prevent="myMethod"
  >

    <section
      class="container-bs"
      :class="{'container-disabled': activeLoading}"
    >
      <div v-if="activeLoading" class="spinner-container">
        <div class="lds-dual-ring" />
      </div>
      <div class="service-request-page__header">
        <h1 v-if="getMain.title">{{ getMain.title }}</h1>
        <p v-if="getMain.description" class="service-request-page__subtitle">
         {{getMain.description}}
        </p>
      </div>

      <div class="service-request-page__form">
        <div class="service-request-page__form-fields">
          <div
            ref="nav"
            class="service-request-page__nav"
          >
            <div
              v-for="(item, itemIndex) in stepItems"
              :key="`itemIndex-${itemIndex}`"
              ref="navItems"
              class="service-request-page__tab"
              :class="{
                'service-request-page__tab--done': item < currentStepIndex,
                'service-request-page__tab--active': item === currentStepIndex,
                'service-request-page__tab--future': item > currentStepIndex
              }"
              @click="changeStepTab(item)"
            >
              <div class="service-request-page__tab-label">
                {{ labelTab(item + 1) }}
              </div>
              <div class="service-request-page__tab-progress">
                <div class="service-request-page__tab-line service-request-page__tab-line--left" />
                <div class="service-request-page__tab-circle">
                  <svg
                    v-if="item < currentStepIndex"
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 5.5L5 9.5L13 1"
                      stroke="#282830"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="service-request-page__tab-line service-request-page__tab-line--right" />
              </div>
            </div>
          </div>
          <div v-if="pageReloadData" class="service-request-page__content">
            <form @submit.prevent>
              <Step1
                v-show="currentStepIndex === 0"
                v-if="!$route.query.dealer"
                :form="form"
                :submitForm="submitForm"
                :dealerItems="dealerItems"
                :errorMsgs="errorMsgs"
                :defaultForm="defaultForm"
                :changeFieldMap="changeFieldMap"
                :doneStepIndex="doneStepIndex"
                :resetStep="resetStep"
                @set-dealer="onSetDealer"
                @update:activeLoading="activeLoading = $event"
              />
              <Step2
                v-show="currentStepIndex === 1"
                :moboiltiesItems="moboiltiesItems"
                :form="form"
                :defaultForm="defaultForm"
                :dealerItems="dealerItems"
                :dealerServices="dealerServices"
                :errorMsgs="errorMsgs"
                :submitForm="submitForm"
                :disable="activeLoading"
                :workPeriod="workPeriod"
                :onServiceChanged="onServiceChanged"
                :requestServiceIn="requestServiceIn"
                :time="time"
                :changeTime="changeTime"
              />
              <Step3
                v-show="currentStepIndex === 2"
                :errorMsgs="errorMsgs"
                :form="form"
                :submitForm="submitForm"
                :onCheckboxUnknownChange="onCheckboxUnknownChange"
                :getVINCodeAction="getVINCodeAction"
                @update:vin_number="form.vin_number = $event"
                @update:state_number="form.state_number = $event"
                @update:unknown_number="form.unknown_number = $event"
                @update:activeLoading="activeLoading = $event"
              />
              <Step4
                v-show="currentStepIndex === 3"
                :form="form"
                :errorMsgs="errorMsgs"
                :defaultForm="defaultForm"
                :submitForm="submitForm"
              />
              <Step5
                v-show="currentStepIndex === 4"
                :moboiltiesItems="moboiltiesItems"
                :dealerServices="dealerServices"
                :changeStepTab="changeStepTab"
                :form="form"
                :errorMsgs="errorMsgs"
                :defaultForm="defaultForm"
                :submitForm="submitForm"
                :infoDealer="infoDealer"
                :dealer="dealer"
              />
            </form>
          </div>
        </div>
      </div>
    </section>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'
  import Step1 from '@/components/main/Step1.vue'
  import Step2 from '@/components/main/Step2.vue'
  import Step3 from '@/components/main/Step3.vue'
  import Step4 from '@/components/main/Step4.vue'
  import Step5 from '@/components/main/Step5.vue'

  export default {
    name: 'MainPage',

    components: {
      Step5,
      Step1,
      Step2,
      Step3,
      Step4
    },

    data () {
      return {
        queryClear: {},
        defaultForm: {},
        pageData: {},
        form: {
          is_validate: false
        },
        dealerItems: (this.getMain && this.getMain.form.dealer_id.items) || [],
        componentReady: false,
        showDatePicker: true,
        errorMsgs: {},
        isChangedForm: false,
        currentStepIndex: this.$route.query.dealer ? 1 : 0,
        doneStepIndex: this.$route.query.dealer ? 1 : 0,
        stepItems: this.$route.query.dealer ? [1, 2, 3, 4] : [0, 1, 2, 3, 4],
        requestServiceIn: 0,
        dealerServices: [],
        workPeriod: Object,
        workPeriodShort: [],
        workPhone: '',
        time: '',
        dealer: {},
        infoDealer: {
          text: ''
        },
        address: '',
        iframeStep2: false,
        pageReloadData: true,
        activeLoading: false,
        moboiltiesItems: [],
        mobilities: []
      }
    },

    computed: {
      ...mapGetters(['getMain', 'isLoad', 'getPhoneType']),
      ...mapState(['currentLang']),

      disabledSteps () {
        if (this.currentStepIndex !== 1) {
          return false
        }
        return !(this.currentStepIndex === 1 && this.form.city_id)
      },

      getOptionsSubService () {
        if (this.dealerItems && this.dealerItems.length && this.form.service_id && this.form.dealer_id) {
          const item = this.dealerItems.filter(item => item.value === this.form.dealer_id) && this.dealerItems.filter(item => item.value === this.form.dealer_id)
          if (item && item[0]) {
            return item[0].sub_services
              .filter(item => {
                return +item.service_id === +this.form.service_id
              })
              .map(item => {
                return {
                  value: item.value,
                  text: item.text
                }
              })
          }
        }
        return []
      },

      getOptionsMobility () {
        if (this.dealerItems && this.dealerItems.length) {
          if (this.dealerItems
            .filter((item) => item.value === this.form.dealer_id).length) {
            // eslint-disable-next-line camelcase
            return this.dealerItems
              .filter((item) => item.value === this.form.dealer_id)[0]
              .mobility
              .map((item) => {
                return {
                  value: item.value,
                  text: item.text
                }
              })
          }
        }
        return []
      },

      datePickerOptions () {
        const dealerId = this.form.dealer_id
        let items = this.getMain.form.date_time.options
        this.dealerItems.forEach(({ value, workPeriod, requestServiceIn }) => {
          if (value === dealerId) {
            items = { datePickerStep: 60, schedule: workPeriod, requestServiceIn, dealerId: value }
          }
        })
        return items
      },
      queryCity () {
        const cityId = Number(this.removeQueryString(this.$route.query.city))
        return isNaN(cityId) ? undefined : cityId
      },
      serviceItems () {
        const dealerId = this.form.dealer_id

        const dealer = this.dealerItems.find(({ value }) => value === dealerId)

        return dealer ? dealer.services : []
      },
      queryServiceValid () {
        const service = Number(this.removeQueryString(this.$route.query.service))
        if (!service) return false

        return this.serviceItems.some(item => Number(item.value) === service)
      }
    },

    watch: {
      'getOptionsMobility': {
        handler (value) {
          if (value.length) {
            this.form.mobility_id = value[0].value
          }
        }
      },
      'dealerItems': {
        handler () {
          if (this.dealerItems.length === 1) {
            this.form.dealer_id = this.dealerItems[0].value
          }
        }
      },
      'form.service_id': {
        handler () {
          this.form.sub_service_id = ''
        }
      },
      'form.vin_number': {
        handler (e) {
          if (e.replace(/\s/g, '').length === 17) {
            document.querySelector('div').focus()
            var tmp = document.createElement('input')
            document.body.appendChild(tmp)
            tmp.focus()
            document.body.removeChild(tmp)
            this.getVinCodeField(e)
          }
        }
      },
      form: {
        deep: true,
        handler (e) {
          const emptyData = [
            e.periodId,
            e.appeal,
            e.first_name,
            e.last_name,
            e.state_number,
            e.email,
            e.date_time,
            e.comment,
            e.vin_number
          ]
          if (
            (emptyData.some(item => item !== '') ||
              e.model !== (this.removeQueryString(this.$route.query.model) || '') ||
              e.dealer_id !==
              (this.$route.query.dealer && Number(this.removeQueryString(this.$route.query.dealer))) ||
              e.city_id !==
              (this.$route.query.city && Number(this.removeQueryString(this.$route.query.city))) ||
              e.service_id !==
              (this.$route.query.service &&
                Number(this.$route.query.service)) ||
              (e.phone !== this.getPhoneType &&
                e.phone !== '+373-' &&
                e.phone !== '+380-' && e.phone !== '') ||
              e.contact_method !== 1 ||
              e.policy !== false) &&
            !this.isChangedForm
          ) {
            this.changedForm()
          }
        }
      },
      $route (to, from) {
        if (from.name === 'service' && to.name === 'thank-you') {
          this.dealerName = _.get(this, '$store.state.dealer.dealerName', '')
          this.dealerId = _.get(this, '$store.state.dealer.dealerId', '')
          this.dealerCity = _.get(this, '$store.state.dealer.dealerCity', '')
          this.zipcode = _.get(this, '$store.state.dealer.zipcode', '')

          this.pushDataToDataLayer(
            {
              page: {
                category: 'tools',
                subCategory: 'form',
                sectionlv1: 'forms',
                sectionlv2: 'book-service',
                language: _.get(this, 'currentLang', '')
              },
              event: {
                name: 'formevent',
                componentName: 'book-service',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'form-submit'
              },
              form: {
                name: 'lead-book-service',
                step: 'form-submit',
                conversion: '1'
              },
              dealer: {
                name: this.dealerName,
                dealerId: this.dealerId,
                city: this.dealerCity,
                zipcode: this.zipcode
              }
            },
            true
          )
        }
        if (from.name === 'thank-you' && to.name === 'service') {
          this.pushDataToDataLayer({
            page: {
              category: 'tools',
              subCategory: 'form',
              sectionlv1: 'forms',
              sectionlv2: 'book-service',
              language: _.get(this, 'currentLang', '')
            },
            form: {
              name: 'lead-book-service',
              step: 'select-service',
              conversion: '0'
            }
          })
        }
      },
      currentStepIndex (v) {
        if (v === 0) {
          this.pushDataToDataLayer({
            page: {
              category: 'tools',
              subCategory: 'form',
              sectionlv1: 'forms',
              sectionlv2: 'book-service',
              language: _.get(this, 'currentLang', '')
            },
            form: {
              name: 'lead-book-service',
              step: 'select-service',
              conversion: '0'
            }
          })
        }
        if (v === 1) {
          this.dealerName =
            _.get(this, 'infoDealer.text') || _.get(this, 'dealer.name')
          this.dealerId =
            _.get(this, 'infoDealer.dealerId') || _.get(this, 'dealer.uuid')
          this.dealerCity =
            _.get(this, 'infoDealer.city') ||
            _.get(this, 'dealer.addresses[0].city')
          this.zipcode =
            _.get(this, 'infoDealer.zipcode') ||
            _.get(this, 'dealer.addresses[0].zip')

          this.$store.commit('SET_DEALER', {
            dealerName: this.dealerName,
            dealerId: this.dealerId,
            dealerCity: this.dealerCity,
            zipcode: this.zipcode
          })

          this.pushDataToDataLayer(
            {
              page: {
                category: 'tools',
                subCategory: 'form',
                sectionlv1: 'forms',
                sectionlv2: 'book-service',
                language:
                  _.get(this, 'currentLang') || _.get(this, 'dealer.language')
              },
              event: {
                name: 'formevent',
                componentName: 'book-service',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'contact-details'
              },
              form: {
                name: 'lead-book-service',
                step: 'contact-details',
                conversion: '0'
              },
              dealer: {
                name:
                  _.get(this, '$store.state.dealer.dealerName', false) ||
                  this.dealerName,
                dealerId:
                  _.get(this, '$store.state.dealer.dealerId', false) ||
                  this.dealerId,
                city:
                  _.get(this, '$store.state.dealer.dealerCity', false) ||
                  this.dealerCity,
                zipcode:
                  _.get(this, '$store.state.dealer.zipcode', false) ||
                  this.zipcode
              }
            },
            true
          )
        }
        if (v === 2) {
          this.dealerName =
            _.get(this, '$store.state.dealer.dealerName', false) ||
            _.get(this, 'infoDealer.text') ||
            _.get(this, 'dealer.name')
          this.dealerId =
            _.get(this, '$store.state.dealer.dealerId', false) ||
            _.get(this, 'infoDealer.dealerId') ||
            _.get(this, 'dealer.uuid')
          this.dealerCity =
            _.get(this, '$store.state.dealer.dealerCity', false) ||
            _.get(this, 'infoDealer.city') ||
            _.get(this, 'dealer.addresses[0].city')
          this.zipcode =
            _.get(this, '$store.state.dealer.zipcode', false) ||
            _.get(this, 'infoDealer.zipcode') ||
            _.get(this, 'dealer.addresses[0].zip')

          this.pushDataToDataLayer(
            {
              page: {
                category: 'tools',
                subCategory: 'form',
                sectionlv1: 'forms',
                sectionlv2: 'book-service',
                language:
                  _.get(this, 'currentLang') || _.get(this, 'dealer.language')
              },
              event: {
                name: 'formevent',
                componentName: 'book-service',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'confirm-booking'
              },
              form: {
                name: 'lead-book-service',
                step: 'confirm-booking',
                conversion: '0'
              },
              dealer: {
                name: this.dealerName,
                dealerId: this.dealerId,
                city: this.dealerCity,
                zipcode: this.zipcode
              }
            },
            true
          )
        }
      }
    },

    created () {
      this.printObjectValues(this.$route.query)
      if (this._.get(this.$route, 'query.country')) {
        this.$store.commit('setCurrentCountry', this.removeQueryString(this.$route.query.country))
      }

      if (this._.get(this.$route, 'query.lang')) {
        this.$store.commit('setCurrentLang', this.removeQueryString(this.$route.query.lang))
      }

      if (this.queryCity) {
        this.fetchDealer(this.queryCity, true)
      }
      this.form = this.getDefaultForm()
    },

    async mounted () {
      if (this.$route.query.dealer) {
        await this.changeFieldMap(this.$route.query.dealer, {}, false)
      }

      if (this._.get(this.$route, 'query.vin')) {
        this.form.vin_number = this._.get(this.$route, 'query.vin')
      }
      // dataLayer start
      window.dataLayer = window.dataLayer || []
      window.tngaDataLayer = window.tngaDataLayer || {}

      const page = {
        category: 'tools',
        subCategory: 'form',
        sectionlv1: 'forms',
        sectionlv2: 'book-service',
        language: _.get(this, 'currentLang', '')
      }

      const form = {
        name: 'lead-book-service',
        step: 'select-service',
        conversion: '0'
      }

      window.tngaDataLayer = { page, form }
      // dataLayer end
    },

    methods: {
      ...mapActions(['submitServiceRequest', 'getServiceRequest']),

      printObjectValues (obj) {
        for (const key in obj) {
          if (obj[key]) {
            obj[key] = obj[key].split('?')[0]
          }
        }
      },
      scrollToActiveTab () {
        const nav = this.$refs.nav
        const items = this.$refs.navItems

        if (!nav || !items.length) return

        const activeItem = items[this.currentStepIndex]

        if (!activeItem) return
        nav.scrollTo({
          left:
            activeItem.offsetLeft -
            nav.offsetWidth / 2 +
            activeItem.offsetWidth / 2,
          behavior: 'smooth'
        })
      },
      myMethod (e) {
        e.preventDefault()
      },
      onServiceChanged (e) {
        if (this.currentStepIndex === 1) {
          this.currentStepIndex = 1
          this.doneStepIndex = 1
        }
      },
      onCheckboxUnknownChange (e) {
        this.currentStepIndex = 2
        this.doneStepIndex = 2
      },
      resetStep () {
        this.currentStepIndex = 0
        this.doneStepIndex = 0
        this.form.service_id = ''
        this.form.date_time = ''
        this.form.mobility_id = ''
      },
      onSetDealer (id) {
        this.form.dealerId = id
      },
      labelTab (e) {
        return this.getMain.tabs && this.getMain.tabs['tab' + e] && this.getMain.tabs['tab' + e].label
      },
      nextStep (e) {
        this.submitForm(e)
      },
      changeTime (e) {
        this.time = e
      },
      removeQueryString (url) {
        if (url) {
          return url.split('?')[0]
        }
        return url
      },
      setPolicy () {
        const stockMarketing = {
          marketingConsentText: this.getMain.marketingConsentText,
          formSubmitUrl: this.getMain.marketingLink,
          closeButtonText: this.getMain.closeButtonText
        }

        const stockPolicy = {
          policyText: this.getMain.policyText,
          formSubmitUrl: this.getMain.policyLabel,
          closeButtonText: this.getMain.closeButtonText
        }

        localStorage.setItem('stockPolicy', JSON.stringify(stockPolicy))
        localStorage.setItem('marketing', JSON.stringify(stockMarketing))

        this.$store.commit('setMarketing', stockMarketing)
        this.$store.commit('setStockPolicy', stockPolicy)
      },

      getVinCodeField (e) {
        this.getVINCodeAction(e)
      },
      async getVINCodeAction (code) {
        try {
          this.activeLoading = true
          const data = await this.getServiceRequest({
            submitUrl: `/service-check-vin/${code}`
          })
          if (!this.form.unknown_number) {
            this.activeLoading = false
          }
          return data
        } catch (error) {
          this.activeLoading = false
        }
      },
      getDefaultForm () {
        return {
          model: this.removeQueryString(this.$route.query.model) || '',
          periodId: '',
          dealer_id: this.$route.query.dealer && Number(this.removeQueryString(this.$route.query.dealer)),
          appeal: 1,
          first_name: '',
          last_name: '',
          state_number: '',
          engine: '',
          year: '',
          mobility_id: '',
          sub_service_id: '',
          unknown_number: false,
          city_id: this.$route.query.city && Number(this.removeQueryString(this.$route.query.city)),
          service_id:
            this.$route.query.service ? Number(this.$route.query.service) : '',
          phone: '',
          date_time: '',
          comment: '',
          vin_number: '',
          contact_method: '',
          policy: true,
          marketing: true,
          middle_name: ''
        }
      },
      async changeFieldMap (id, data) {
        if (id === this.form.dealerId) return
        try {
          this.moboiltiesItems = []
          this.dealer = data
          this.form.date_time = ''
          this.form.city_id = ''
          this.form.service_id = this.$route.query.service ? Number(this.$route.query.service) : ''
          this.doneStepIndex = 0
          this.resetDatePicker()
          this.infoDealer = {}
          const errors = await this.getServiceRequest({
            submitUrl: `/dealer/dealer?id=${id}`
          })
          if (!errors) {
            return this.$router.push('/404')
          }
          this.form.mobility_id = ''
          this.dealerServices = errors.services
          this.moboiltiesItems = errors.mobility
          this.form.dealer_id = errors.value
          this.form.dealerId = errors.value
          this.form.city_id = errors.city_id
          this.address = errors.address
          this.requestServiceIn = errors.requestServiceIn
          this.workPeriod = errors.workPeriod
          this.workPeriodShort = errors.workPeriodShort
          this.workPhone = errors.phone
          this.infoDealer = errors
          this.time = null
          this.time = ''
        } catch (er) {
          this.currentStepIndex = 1
          console.log('er', er)
        }
      },
      changeStepTab (index) {
        if (this.doneStepIndex >= index) {
          this.currentStepIndex = index
          this.$nextTick(() => {
            this.scrollToActiveTab()
          })
        }
      },
      changedForm () {
        this.pushDataToDataLayer(
          {
            events: {
              name: 'formevent',
              componentName: 'book-service',
              componentGroup: 'forms',
              action: 'form-step',
              label: 'form-fill-start'
            },
            forms: {
              name: 'lead-book-service',
              step: 'form-fill-start',
              conversion: '0'
            }
          },
          true
        )
        this.isChangedForm = true
      },
      async clearForm () {
        this.pageReloadData = false
        setTimeout(() => {
          this.pageReloadData = true
        }, 100)
        Object.assign(this.$data, {
          pageData: {},
          form: {
            is_validate: false
          },
          dealerItems: (this.getMain && this.getMain.form.dealer_id.items) || [],
          componentReady: false,
          showDatePicker: true,
          errorMsgs: {},
          isChangedForm: false,
          currentStepIndex: 0,
          doneStepIndex: 0,
          stepItems: [0, 1, 2, 3, 4],
          requestServiceIn: 0,
          workPeriod: Object,
          workPeriodShort: [],
          workPhone: '',
          dealerServices: [],
          time: '',
          dealer: {},
          infoDealer: {
            text: ''
          },
          address: '',
          iframeStep2: false
        })
        this.form = this.getDefaultForm()
        const inputs = [
          ...document.querySelectorAll(
            '.input-wrapper input, .input-wrapper textarea'
          )
        ]
        inputs.forEach(input => {
          input.value = ''
        })
        this.dealerItems = []
        this.showDatePicker = false
        await this.$nextTick()
        this.showDatePicker = true
      },
      async submitForm (isValidate = true) {
        this.errorMsgs = {}

        const payload = {
          ...this.form,
          is_validate: this.currentStepIndex === 4,
          date_time: this.form.date_time && this.form.date_time / 1000 // timestamp in seconds, not miliseconds
        }

        const errorFn = errors => {
          if (typeof errors !== 'object') {
            console.warn('response errors is not a object', { errors })
          }
          Object.keys(errors).forEach(errKey => {
            this.$set(this.errorMsgs, errKey, errors[errKey])
          })
        }

        const dealerId = _.get(this, 'form.dealer_id', '')
        const dealerName = this.checkNull(
          _.get(
            _.get(this, 'dealerItems', []).find(item => item.value === dealerId),
            'text',
            ''
          )
        )

        try {
          const errors = await this.submitServiceRequest({
            submitUrl: `/service${
              this._.get(this.$route, 'query.country')
                ? '?country=' + this._.get(this.$route, 'query.country')
                : ''
            }`,
            form: payload
          })

          this.pushDataToDataLayer(
            {
              events: {
                name: 'formevent',
                componentName: 'book-service',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'form-submit'
              },
              forms: {
                name: 'lead-book-service',
                step: 'form-submit',
                conversion: '1'
              },
              dealers: {
                dealer: {
                  name: dealerName,
                  dealerId,
                  city: this.checkNull(
                    _.get(
                      _.get(this, 'getMain.form.city_id.items', []).find(
                        item => item.value === _.get(this, 'form.city_id', '')
                      ),
                      'text',
                      ''
                    )
                  ),
                  zipcode: this.checkNull(
                    _.get(
                      _.get(this, 'dealerItems', []).find(
                        item => item.value === dealerId
                      ),
                      'zipcode',
                      ''
                    )
                  )
                }
              }
            },
            true,
            {
              event: 'form_send',
              formModel: _.get(this, 'form.model', ''),
              formDealer: dealerName
            }
          )

          if (errors.title) {
            const data = {
              description: errors.description,
              title: errors.title
            }
            this.$router.push({ name: 'thank-you', params: data })
            setTimeout(() => {
              this.clearForm()
            }, 500)
            return
          }

          window.scrollTo({ top: 0, behavior: 'smooth' })

          if (!errors.title) {
            if (isValidate) {
              errorFn(errors)
            }
          }
        } catch (e) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
          const errors = e && e.response && e.response.data
          console.error('FAILED: submitServiceRequest')
          console.log({ e })

          const oldStep = this.currentStepIndex
          if (
            this.currentStepIndex === 0 &&
            !errors.dealerId
          ) {
            if (this.$route.query.dealer) {
              this.$set(this, 'currentStepIndex', 2)
              this.doneStepIndex = 2
              this.scrollToActiveTab()
            } else {
              this.$set(this, 'currentStepIndex', 1)
              if (!this.form.date_time && !this.form.service_id) {
                this.currentStepIndex = 1
                this.doneStepIndex = 1
                this.scrollToActiveTab()
              }
            }
            this.errorMsgs = {}
            return
          }
          if (
            this.currentStepIndex === 1 &&
            !errors.service_id &&
            !errors.date_time &&
            !errors.mobility_id &&
            ((this.$route.query.dealer && oldStep === 1) ||
              !this.$route.query.dealer)
          ) {
            this.$set(this, 'currentStepIndex', 2)
            this.doneStepIndex = 2
            this.errorMsgs = {}
            this.scrollToActiveTab()
            return
          }
          if (
            this.currentStepIndex === 2 &&
            !errors.state_number &&
            !errors.vin_number
          ) {
            this.$set(this, 'currentStepIndex', 3)
            if (this.doneStepIndex === 2) {
              this.doneStepIndex = 3
            }
            this.scrollToActiveTab()
            this.errorMsgs = {}
            return
          }
          if (
            this.currentStepIndex === 3 &&
            !errors.last_name &&
            !errors.first_name &&
            !errors.phone &&
            !errors.contact_method

          ) {
            this.$set(this, 'currentStepIndex', 4)
            if (this.doneStepIndex === 3) {
              this.doneStepIndex = 4
            }
            this.scrollToActiveTab()
            this.errorMsgs = {}
            return
          }
          if (isValidate) {
            errorFn(errors)
          }
        }
      },
      async fetchDealer (cityId, isFromQuery) {
        this.form.service_id = this.$route.query.service ? +this.$route.query.service : ''
        if (isNaN(Number(cityId))) {
          this.dealerItems = []
          console.warn('City id is not valid ', { cityId })
          return
        }
        const { data } = await window.axios
          .get('/dealer/list', { params: { city: cityId } })
          .catch(e => console.warn('Fetch Dealer error', { e }))
        if (!isFromQuery) {
          this.form.dealer_id = ''
          this.form.date_time = ''
          this.$refs.datePicker.date = ''
          this.$refs.datePicker.time = ''
          this.resetService()
        }
        this.form.mobility_id = ''
        this.dealerItems = data
      },
      resetService () {
        this.form.mobility_id = ''
        this.resetDatePicker()
        this.defaultForm = {}
      },
      resetDatePicker () {
        try {
          this.form.date_time = ''
          if (this.$refs.datePicker) {
            this.$refs.datePicker.date = ''
            this.$refs.datePicker.time = ''
          }
        } catch (er) {
          console.log(er)
        }
      },

      checkNull (data) {
        if (data) return data
        return ''
      },
      pushDataToDataLayer (
        params = {},
        pushDataLayer = false,
        dataForDataLayerCustom = false
      ) {
        // dataLayer start
        window.dataLayer = window.dataLayer || []

        const event = params.events || {}

        const page = {
          category: 'tools',
          subCategory: 'form',
          sectionlv1: 'forms',
          sectionlv2: 'book-service',
          language: _.get(this, 'currentLang', '')
        }

        const form = params.forms || {}

        window.tngaDataLayer = { event, page, form, ...params.dealers }

        if (pushDataLayer) {
          window.dataLayer.push({ event: 'formevent' })
        }
        if (dataForDataLayerCustom) {
          window.dataLayer.push(dataForDataLayerCustom)
        }
        // dataLayer end
      }
    }
  }
</script>

<style lang="scss">
.service-page {
  min-height: 100vh;

  .margin-space {
    margin-bottom: 100px;
  }

  .container-wrapper {
    max-width: 1170px;
    padding-top: 110px;

    @media only screen and (max-width: 1279px) {
      //max-width: 768px;
      padding-top: 55px;
      padding-right: 10px;
      padding-left: 10px;
    }

    @include mobile {
      padding-top: 50px;
      padding-right: 0;
      padding-left: 0;
    }
  }
}

// Base styles shared with FleetPage
.service-request-page {
  padding-bottom: 70px;

  @include mobile {
    padding-bottom: 40px;
  }

  .input__error-msg,
  .select__error-msg {
    width: 100% !important;
  }

  .checkbox-wrapper {
    width: 100%;
  }

  &__form {
    padding-bottom: 25px;
    border-bottom: 1px solid $c-gray;

    @include mobile {
      padding-bottom: 35px;
    }

    &-filters {
      display: flex;
      justify-content: space-between;

      @include mobile {
        flex-direction: column;
      }
    }

    &-fields {
      @media (min-width: 767.9px) {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        > * {
          width: 348px;
        }
      }
    }

    &-input {
      margin-bottom: 10px;

      @include mobile {
        min-width: 100%;
        margin-bottom: 5px;
      }

      &:last-child {
        margin-top: 0;
        margin-bottom: 0;
      }
    }
  }

  &__table {
    margin: 40px 0;

    @include mobile {
      margin: 20px 0;
    }
  }

  &__editor-wrapper {
    padding-top: 40px;

    @include mobile {
      padding-top: 30px;
    }
  }

  &__editor {
    * {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      color: $c-gray-dark;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: $c-black;
    }

    h1 {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-size: 40px;
      font-weight: 700;
      line-height: 44px;

      @include mobile {
        font-size: 24px;
        line-height: 1.42;
      }
    }

    h2 {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-weight: 400;
      line-height: 35px;

      @include mobile {
        line-height: 24px;
      }
    }

    h3 {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-size: 21px;
      font-weight: 400;
      line-height: 30px;

      @include mobile {
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
      }
    }

    h4 {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-size: 21px;
      font-weight: 400;
      line-height: 23px;

      @include mobile {
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
      }
    }

    h5,
    h6 {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-size: 16px;
      font-weight: 900;
      line-height: 26px;

      @include mobile {
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
      }
    }

    a {
      font-size: 16px;

      &:hover {
        color: $c-active;
        text-decoration: none;
        border-bottom: 0;
        transition: 0.5s;
      }

      @include mobile {
        font-size: 16px;
      }
    }

    strong {
      font-weight: 900;
    }

    ol,
    ul {
      margin-left: 20px;

      li {
        padding-left: 10px;
      }
    }
  }

  &__pd {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }

  &__policy {
    display: flex;
    justify-content: flex-start;
    padding-top: 40px;
    width: 100%;

    @include mobile {
      padding-top: 30px;
    }
  }

  &__submit-button-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    @include mobile {
      margin-top: 10px;
    }
  }
}

// MainPage-only overrides (scoped to .service-page)
.service-page .service-request-page {
  padding-bottom: 0;
  flex: 1;
  height: 100%;

  .service-request-page__header {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 40px;

    @include tablet {
      margin-bottom: 46px;
    }

    @include mobile {
      margin-bottom: 50px;
    }

    h1 {
      font-family: "ToyotaType", Arial, Helvetica, sans-serif;
      font-size: 64px;
      font-weight: 400;
      line-height: 72px;
      color: $c-gray-dark;
      margin: 0;
      text-align: left;
      text-transform: none;

      @include mobile {
        font-size: 34px;
        line-height: 34px;
      }
    }
  }

  .service-request-page__subtitle {
    font-family: "ToyotaType", Arial, Helvetica, sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: $c-gray-dark;
    max-width: 50%;

    @include tablet {
      max-width: 75%;
      line-height: 26px;
    }

    @include mobile {
      max-width: 100%;
      line-height: 22px;
    }
  }

  .service-request-page__content {
    .icon-left {
      position: relative;
      top: -1px;
      margin-left: 8px;
      color: $c-white;
    }

    @include mobile {
      max-width: 100%;
    }
  }

  .service-request-page__form {
    border-bottom: none;

    .service-request-page__form-fields > * {
      @media (min-width: 767.9px) {
        width: 100%;
      }
    }
  }

  .service-request-page__editor-wrapper {
    padding-top: 0;

    @include mobile {
      padding-top: 30px;
    }
  }

  .service-request-page__editor * {
    font-family: 'ToyotaType', sans-serif;
    line-height: 1.23;
    color: $c-gray-7;
    letter-spacing: -0.22px;

    strong {
      color: $c-gray-dark;
      letter-spacing: 0;
    }

    @include tablet {
      line-height: 1.12;

      strong {
        line-height: 1.4;
      }
    }
  }

  .service-request-page__editor h1 {
    font-size: 64px;
    font-weight: 400;
    line-height: 72px;

    @media (max-width: 1024px) {
      font-size: 40px;
      line-height: 44px;
    }
  }

  .service-request-page__nav {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    margin-bottom: 42px;
    cursor: pointer;

    @media (max-width: 1024px) {
      display: flex;
      margin-bottom: 46px;
      overflow: hidden;
    }
  }

  .service-request-page__tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 0;
    gap: 8px;

    @media (max-width: 1024px) {
      min-width: 0;
      flex: 1;
      padding: 0;
      gap: 0;
    }

    &-label {
      font-family: 'ToyotaType-Book', Arial, Helvetica, sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: $c-gray-dark;
      white-space: nowrap;

      @media (max-width: 1024px) {
        display: none;
      }
    }

    &-progress {
      display: flex;
      align-items: center;
      width: 100%;
    }

    &-line {
      flex: 1;
      height: 1px;

      &--left,
      &--right {
        background-color: $c-gray-6;
      }
    }

    &-circle {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      border: 1px solid $c-gray-6;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      background: $c-white;
    }

    &--done {
      .service-request-page__tab-line {
        background-color: $c-gray-dark;
        height: 2px;
      }

      .service-request-page__tab-circle {
        border-color: $c-gray-dark;
        border-width: 2px;
      }
    }

    &--active {
      .service-request-page__tab-line--left {
        height: 2px;
        background-color: $c-gray-dark;
      }

      .service-request-page__tab-line--right {
        background-color: $c-gray-6;
      }

      .service-request-page__tab-circle {
        border-color: $c-gray-dark;
        border-width: 2px;
      }
    }

    &--future {
      .service-request-page__tab-line {
        background-color: $c-gray-6;
      }

      .service-request-page__tab-circle {
        border-color: $c-gray-6;
      }
    }
  }
}

.spinner-container {
  z-index: 333;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.lds-dual-ring {
  display: inline-block;
  width: 60px;
  height: 60px;

  &:after {
    -webkit-animation: lds-dual-ring 1.2s linear infinite;
    animation: lds-dual-ring 1.2s linear infinite;
    border-color: #000 transparent;
    border-radius: 50%;
    border-style: solid;
    border-width: 3px;
    content: " ";
    display: block;
    height: 60px;
    margin: 4px;
    width: 60px;
    animation-name: spin;
    animation-duration: 2000ms;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
